import { Dropdown } from 'react-bootstrap'
import styled from 'styled-components'

export const StyledDropdown = styled(Dropdown)`
  margin: 0;
  .toggle-profile {
    margin: auto 20px !important;
  }
`

export const ImgBadge = styled.div`
  width: 10px;
  height: 10px;
  background-color: ${({ theme }) => theme.mojoAccent3};
  border-radius: 10px;
  position: absolute;
`

export const DropdownMenu = styled(Dropdown.Menu)`
  border-radius: 5px;
  margin: 5px !important;
  background-color: ${({ theme }) => theme.grey10};
  color: ${({ theme }) => theme.grey70};
  .dropdown-header {
    color: ${({ theme }) => theme.grey100};
    font-weight: bold;
  }
  .dropdown-item {
    color: ${({ theme }) => theme.grey70};
  }

  .dropdown-item:hover,
  :focus {
    background-color: ${({ theme }) => theme.grey30};
    color: ${({ theme }) => theme.grey100};
  }
`
export const TenantInputContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 2px;
  margin-right: 20px;
  max-width: 260px;
  @media (min-width: 1200px) {
    width: 260px;
    margin-top: -15px;
    margin-right: 20px;
    img {
      margin: auto 10px auto 30px;
    }
  }
  @media (max-width: 1200px) {
    img {
      display: none;
    }
  }
`
